import client from './client.js';

export const uploadPrescription = async (file, { onUploadProgress } = {}) => {
  const form = new FormData();
  form.append('file', file);
  // OCR (Google Vision + Claude) pode levar dezenas de segundos — sobrepõe o timeout padrão de 15s
  const { data } = await client.post('/orders/prescription', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 90_000,
    onUploadProgress,
  });
  return data;
  // { prescription_url, ocr: { doctor, exams, medications, confidence } }
};

export const createOrder = async (payload) => {
  const { data } = await client.post('/orders', payload);
  return data;
};

export const getOrder = async (id) => {
  const { data } = await client.get(`/orders/${id}`);
  return data;
};

export const cancelOrder = async (id, password) => {
  const { data } = await client.post(`/orders/${id}/cancel`, { password });
  return data;
};

// Meus Pedidos — filtro por status (chip da UI) e paginação, resolvidos no servidor
export const listOrders = async ({ status, page, pageSize } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (page) params.page = page;
  if (pageSize) params.page_size = pageSize;
  const { data } = await client.get('/orders', { params });
  return data;
};

// Compra combinada: um pedido por laboratório, pagos numa cobrança só
export const createOrderGroup = async (payload) => {
  const { data } = await client.post('/orders/group', payload);
  return data; // lista de pedidos (mesmo checkout_group_id)
};
